<template>
  <g 
    id="Capa_2" 
    data-name="Capa 2"
    :fill="iconColor"
  >
    <g 
      id="Capa_1-2" 
      data-name="Capa 1"
    >
      <path
        class="cls-1"
        d="M5382.41,1607.35c-47.15,31.38-111.35,63.08-190,72-113.93,12.91-192.83-29.47-357.45-96-202.9-82-304.35-123-386-136.85-41.26-7-304.55-14.66-561,129.63-44.3,24.93-81.56,56.33-120.19,88.87-48,40.43-104.64,67-152.7,106.86-42.22,35-90.54,62-141.12,82.9-50.15,20.72-104.65,38.86-158.28,47.62-59.75,9.77-120.75,5.19-180.65-.71-8.7-.85-17.5-1.76-25.69-4.79-24.3-9-31-37.76-40.43-59-5.46-12.26-11.79-24.33-20.68-34.48-10.58-12.07-24.39-20.33-39.42-25.68-72.66-25.88-160.69-33.19-237-26.16q-16.72,1.54-33.28,4.35a391.33,391.33,0,0,0-45.35,10.43,415.54,415.54,0,0,0-96.85,42.8c-29.7,17.78-57.16,38.57-83.06,61.48a775.93,775.93,0,0,0-61.22,60.85,51.8,51.8,0,0,1-8.68,7.72,148.61,148.61,0,0,1-31.92,17.11c-20.24,7.89-41.36,11.27-62.94,12.1a297.26,297.26,0,0,1-46.49-2.24c-13.62-1.61-27.1-3.94-40.52-6.73-20.81-4.33-41.28-9.94-61.58-16.18-21.17-6.52-42-13.92-62.83-21.55a46.17,46.17,0,0,0-7.16-2.27c-5.83-1.09-11.7-2-17.59-2.8q-14.25-1.92-28.57-3.34c-10.47-1-21-1.59-31.46-1.93a316,316,0,0,0-58.06,3.53,221,221,0,0,0-39.83,9.82c-19.59,6.91-37.46,16.82-53.15,30.53a57.16,57.16,0,0,0-9.16,10.12,172.68,172.68,0,0,1-51.16,47.93,193.07,193.07,0,0,1-35.13,16.89c-24,8.77-48.87,13.22-74.26,15.12-3.41.26-6.84.36-10.27.53a11.11,11.11,0,0,0-4.64,1h-30.16a21.41,21.41,0,0,0-3.21-1.12c-5.61-1-11.24-2-16.87-2.9-19.36-3.28-38.58-7.29-57.72-11.68a1409.52,1409.52,0,0,1-136.3-38.74c-48.91-16.55-96.89-35.47-144.15-56.27-57.52-25.31-113.71-53.3-169-83.13-52.68-28.41-104.43-58.44-155.58-89.51Q989.25,1754.8,975,1746a58.13,58.13,0,0,1-17.53-16.14,39,39,0,0,1-7.34-23.11,54.51,54.51,0,0,1,3.79-19.38,100.27,100.27,0,0,1,9.76-18.82,31.57,31.57,0,0,1,7.12-8.24,37.78,37.78,0,0,0,8.67-9.64,31.18,31.18,0,0,0,4.43-24.26,50.3,50.3,0,0,0-3.75-11,77.59,77.59,0,0,0-7.37-12.33A131,131,0,0,0,955,1583.14a251.49,251.49,0,0,0-19.59-16.1,326.26,326.26,0,0,0-36.26-23.36c-11.78-6.54-23.67-12.88-35.54-19.27-10.66-5.73-21.31-11.49-31.63-17.82a62.8,62.8,0,0,1-6.77-4.64,429.43,429.43,0,0,1-58.88-57.25,475.89,475.89,0,0,1-34.81-47.51q-6.54-10.07-12.4-20.52c-5-9-10.39-17.73-15.67-26.55a86.93,86.93,0,0,0-8.09-11q-21.14-25.23-44.61-48.33a597.78,597.78,0,0,0-76.7-64.08,420.31,420.31,0,0,0-59-34.76,283.24,283.24,0,0,0-46.68-17.73,187.87,187.87,0,0,0-29.52-5.88,152.27,152.27,0,0,0-30.11-.62,117.77,117.77,0,0,0-29.4,6.13c-5.38,1.9-10.82,3.66-16.31,5.18a230.26,230.26,
        0,0,1-56.82,8.09,310.49,310.49,0,0,1-33.55-1c-12.3-1.07-24.52-2.68-36.65-4.91a440.07,440.07,0,0,1-55.73-14.08,629.21,
        629.21,0,0,1-175-88A21.28,21.28,0,0,0,0,1076.21V0H5382.4Z"
      />
    </g>
  </g>
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      required: false,
      default: "red",
    },
    iconBorder: {
      type: String,
      required: false,
      default: "black",
    },
  },
};
</script>

<style scoped>
path {
  font-family: var(--iconFontFamily);
  font-size: var(--iconFontSize);
}
</style>